class SerialNoInvalidError extends Error {
  constructor(serialNo: unknown) {
    super(`The given hardware serial number is invalid ${serialNo}`)
  }
}
export default SerialNoInvalidError
